import { Box, CheckBox as CheckBoxG, TextInput as TextInputG } from 'grommet'

import styled, { css } from 'styled-components'

import { device } from '../../theme/device'

export const RelativeBox = styled(Box)`
  position: relative;
`

export const AbsoluteBox = styled(Box)`
  position: absolute;
  ${props =>
    props.top &&
    css`
      top: ${props.top};
    `}
  ${props =>
    props.bottom &&
    css`
      bottom: ${props.bottom};
    `}
  ${props =>
    props.left &&
    css`
      left: ${props.left};
    `}
  ${props =>
    props.right &&
    css`
      right: ${props.right};
    `}
  ${props =>
    props.transform &&
    css`
      transform: ${props.transform};
    `}
`

export const UploadInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`

export const CheckBox = styled(CheckBoxG)`
  & + div {
    height: ${props => props.size};
    width: ${props => props.size};
    ${props =>
      props.sizeMedium &&
      css`
        @media ${props.mediaMedium || device.medium} {
          height: ${props => props.sizeMedium};
          width: ${props => props.sizeMedium};
        }
      `}
    svg {
      width: ${props => props.size};
      height: ${props => props.size};
      ${props =>
        props.sizeMedium &&
        css`
          @media ${device.medium} {
            height: ${props => props.sizeMedium};
            width: ${props => props.sizeMedium};
          }
        `}
    }
  }
`

CheckBox.defaultProps = {
  size: '3.5rem',
}

export const TextInput = styled(TextInputG)`
  background-color: ${props => props.theme.global.colors.secondaryBg};
  border: none;
  border-radius: 0px;
  flex: 1;
  min-width: 28rem;
  ::-webkit-input-placeholder {
    color: inherit;
    opacity: 0.54;
  }
  /* padding: 0.5rem; */
`
